import defaultHref from '../assets/images/afp.jpg';

/* global createImageBitmap */

function createWorker(f) {
  return new Worker(URL.createObjectURL(new Blob([`(${f})()`])));
}

const worker = createWorker(() => {
  self.addEventListener('message', (e) => {
    const src = e.data;
    fetch(src, { mode: 'cors' })
      .then(response => response.blob())
      .then(blob => createImageBitmap(blob))
      .then((bitmap) => {
        self.postMessage({ src, bitmap }, [bitmap]);
      });
  });
});

function loadImageWithWorker(src) {
  return new Promise((resolve, reject) => {
    function handler(e) {
      if (e.data.src === src) {
        worker.removeEventListener('message', handler);
        if (e.data.error) {
          reject(e.data.error);
        }
        resolve(e.data.bitmap);
      }
    }
    worker.addEventListener('message', handler);
    worker.postMessage(src);
  });
}

const loader = loadImageWithWorker;

export default class Media {
  static wait = new Promise(resolve => resolve());
  static defaultLarge = {
    role: 'HighDef',
    width: 768,
    href: window.location.origin + defaultHref,
    type: 'Photo',
    height: 432,
  }
  static defaultSmall = {
    role: 'Quicklook',
    width: 512,
    href: window.location.origin + defaultHref,
    type: 'Photo',
    height: 288,
  }
  static defaultVideo = {
    role: 'Video',
    width: 768,
    href: window.location.origin + defaultHref,
    type: 'Photo',
    height: 432,
  }
  constructor(bagItem = {}, faces = []) {
    const medias = bagItem.medias || [];

    this.id = bagItem.uno || `id${Math.random().toString(36).substr(2, 9)}`;
    this.creator = bagItem.creator;
    this.provider = bagItem.provider;
    this.caption = bagItem.caption;
    this.source = bagItem.source;
    this.medias = [
      medias.find(m => m.role === Media.defaultLarge.role) || Media.defaultLarge,
      medias.find(m => m.role === Media.defaultSmall.role) || Media.defaultSmall,
      medias.find(m => m.type === Media.defaultVideo.role) || Media.defaultVideo,
    ].map(media => ({
      ...media,
      faces: faces.filter(f => f.src === media.href),
    }));
    this.preload = {};
  }
  preloadImage(role = Media.defaultLarge.role) {
    if (!this.preload[role]) {
      this.preload[role] = new XMLHttpRequest();
      this.preload[role].open('GET', this.getPhoto(role).href, true);
      this.preload[role].send(null);
    }
  }
  getTexture(role = Media.defaultLarge.role) {
    const photo = this.getPhoto(role);

    if (!this.preload[role]) {
      this.preloadImage(role);
    }

    return loader(photo.href);
  }
  getImage(role = Media.defaultLarge.role) {
    return this.getPhoto(role).href;
  }
  getPhoto(role = Media.defaultLarge.role) {
    return this.medias.find(m => m.role === role);
  }
  getVideo() {
    return this.medias.find(m => m.type === 'Video');
  }
}



// WEBPACK FOOTER //
// ./src/models/Media.js